import styles from './ContainerLayout.module.css';
import { PostAuthFlows } from '../pages/AuthResponse';

const ContainerLayout = ({
  children,
  currentPostAuthFlow,
  enableResponsiveStyles,
  testId,
}: {
  children: React.ReactNode;
  currentPostAuthFlow?: PostAuthFlows;
  enableResponsiveStyles?: boolean;
  testId?: string;
}) => {
  let classes = styles.container;
  if (enableResponsiveStyles || currentPostAuthFlow) {
    const isProfileAndPreferences =
      currentPostAuthFlow === PostAuthFlows.ProfileAndPreferences;
    classes = `${styles.responsiveContainer} ${
      isProfileAndPreferences ? styles.max : styles.default
    }`;
  }

  return (
    <div data-testid={testId} className={classes}>
      {children}
    </div>
  );
};

export default ContainerLayout;
